/**
 * Join waitlist (sections/product-spotlight.liquid): a button with data-stay-waitlist="<Klaviyo form ID>" opens
 * the client's Klaviyo form through Klaviyo's own queue, as the PDP buy box does (stay-product.js). A <button>, so
 * a click, a tap, Enter and Space all arrive here as a click. Without Klaviyo on the page (blocked, failed) it does
 * nothing: the call only waits in the queue, and an error inside Klaviyo is caught. Never a fallback to the cart.
 */
if (!window.stayWaitlist) {
  window.stayWaitlist = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-stay-waitlist]');
    if (!button) return;
    const formId = button.dataset.stayWaitlist.trim();
    if (!formId) return;
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    } catch (error) {
      // Klaviyo's failure is not the page's: nothing to do
    }
  });
}
